<!--    
@description 登录
@author zhijie.huang
@date 2018/9/11
@version v1.1.0
-->
<style scoped>
  .login_content {
    position: relative;
    padding: 0;
    top: 0;
    height: 100%;
  }
  .login-header {
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #ddd;
  }
  .login-header__img {
    position: relative;
    top: 40%;
    transform: translateY(-50%);
  }
  .login {
    display: flex;
    padding: 20px;
    align-items: center;
  }
  .login-header > div > span{
    padding: 0 6px; cursor: pointer;
  }
  .login-header > div > span.active{
    color: #0B8DE5;
  }
  .login__img {
    position: absolute;
    left: 115px;
    top: 117px;
    width: 513px;
    height: 513px;
  }
  .login__box {
    margin-top: -30%;
    padding: 20px;
    width: 400px;
    height: 300px;
    box-shadow: 0 0 6px #bbb;
  }
  .login__box .el-form-item {
    margin-bottom: 24px;
  }
  .login__box-title {
    font-size: 20px;
    line-height: 60px;
  }
  .login__box-btn {
    width: 100%;
  }
  .login .el-input-group__append .el-button {
    width: 140px;
    color: #fff;
    background-color: #0B8DE5;
    border-color: #0B8DE5;
  }
  .login .el-input-group__append .el-button:hover {
    background: #3ca4ea;
    border-color: #3ca4ea;
    color: #fff;
  }
</style>

<template>
  <div class="login_content tabView">
    <el-container style="height: 100%;">
      <el-header class="login-header">
        <!-- <div class="fr">
          <span @click="changeLang('zh-CN')" :class="{'active': langType == 'zh-CN'}">简体中文</span> / 
          <span @click="changeLang('en-US')" :class="{'active': langType == 'en-US'}">English</span>
        </div> -->
        <img class="login-header__img" src="@/assets/image/base/logo.png" />
      </el-header>
      <el-container>
        <el-main>
          <img class="login__img" src="@/assets/image/base/bg.png" />
        </el-main>
        <el-aside class="login" width="40%">
          <div class="login__box">
            <h1 class="login__box-title">{{ $t("login.login") }}</h1>
            <el-form ref="loginform" :model="form" :rules="rules" size="large" label-width="0" input-width="auto">
              <el-form-item prop="username">
                <el-input v-model="form.username" prefix-icon="uk-icon-service" :placeholder="$t('login.username')"></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input v-model="form.password" type="password" prefix-icon="uk-icon-goods" :placeholder="$t('login.password')" @keyup.enter.native="submitForm('loginform')"></el-input>
              </el-form-item>
              <el-form-item prop="verificationCode" v-show="this.codeFlag">
                <el-input v-model="form.verificationCode" :placeholder="$t('login.verificationCode')">
                  <el-button slot="append" v-text="verificationText" :disabled="times !== 59" @click="sendVerification"></el-button>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="login__box-btn" @click="submitForm('loginform')">{{ $t("login.login") }}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-aside>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import LoginBiz from '../logic/loginBiz'
import { Loading } from 'uke-ui'

export default {
  data () {
    return {
      form: {
        username: '',
        password: '',
        verificationCode: ''
      },
      rules: {
        username: [
          { required: true, message: this.$t('login.usernameTips') }
        ],
        password: [
          { required: true, message: this.$t('login.passwordTips') }
        ]
      },
      verificationText: this.$t('login.send'),
      codeFlag: false,
      sendTimer: null,
      times: 59,
      loginCustomerId: '',
      langType: ''
    }
  },
  components: {
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.login(this.form.username, this.form.password, this.form.verificationCode)
        } else {
          return false
        }
      })
    },
    login (username, password, verificationCode) {
      LoginBiz.login(username, password, verificationCode).then((data) => {
        Loading.service({
          target: '.tabView',
          text: this.$t('login.success')
        })
        setTimeout(() => {
          this.$router.push('/home')
          this.clearSendTimer()
        }, 150)
      }).catch((err) => {
        if (err.resultCode === '20000012') {
          this.codeFlag = true
          this.loginCustomerId = err.data.loginCustomerId
        } else {
          console.error(err)
        }
      })
    },
    changeLang (type) {
      this.langType = type
      this.$i18n.locale = type === 'zh-CN' ? 'zh' : 'en'
      localStorage.setItem('language', type)
    },
    sendVerification () {
      LoginBiz.getVerificationCode({ loginCustomerId: this.loginCustomerId }).then(data => {
        this.verificationText = `${this.times}${this.$t('login.waitSecond')}`
        this.$message({
          message: this.$t('login.verificationSend'),
          type: 'success'
        })
        this.setSendTimer()
      })
    },
    setSendTimer () {
      if (this.times > 0) {
        this.sendTimer = setTimeout(() => {
          this.times--
          this.verificationText = `${this.times}${this.$t('login.waitSecond')}`
          this.setSendTimer()
        }, 1000)
      } else {
        this.clearSendTimer()
      }
    },
    clearSendTimer () {
      clearTimeout(this.setSendTimer)
      this.sendTimer = null
      this.times = 59
      this.verificationText = this.$t('login.reSend')
    },
    e_logout () {
      LoginBiz.logout()
    }
  },
  watch: {
    codeFlag (val) {
      if (val) {
        this.rules.verificationCode = [
          { required: true, message: this.$t('login.verificationCode') }
        ]
      } else {
        delete this.rules.verificationCode
      }
    },
    'form.username': {
      deep: true,
      handler: function (val) {
        if (val) {
          this.clearSendTimer()
          this.verificationText = this.$t('login.send')
          this.codeFlag = false
        }
      }
    }
  },
  mounted () {
    if(!localStorage.getItem('language')) localStorage.setItem('language', 'zh-CN')
    this.langType = localStorage.getItem('language')
    this.$i18n.locale = this.langType === 'zh-CN' ? 'zh' : 'en'
  }
}
</script>
